module.exports = __webpack_public_path__ + "img/twitter.20aa33e2.svg";